import { defineStore } from 'pinia'
import { useUserStore } from './userStore'
import { useMessageStore } from './messageStore'
import { useChatListStore } from './chatListStore'
import { useTranslatChangeStore } from './useTranslateChangeStore'
//@ts-ignore
import { v4 as uuidv4 } from 'uuid'
import { timeUtilNowMoment } from '@/utils/timeUtil'
import { noticeWarning, noticeError } from '@xr-util/xr-ui'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ThirdApp } from '@/server/third_request'
import { translateByOneID, querySessionList } from '@/server/session_request'

import { toRaw } from 'vue'
/* import { useI18n } from 'vue-i18n'; */
import i18n from '@/locales'
import { ElNotification } from 'element-plus'
import { WarnTriangleFilled } from '@element-plus/icons-vue'
import { Log } from '@icon-park/vue-next/es/map'
const { t } = i18n.global as any
const wsBase = import.meta.env.VITE_WS_BASE
// import { Base64 } from 'js-base64'

interface IWebSocket {
  ws: any
  isConnected: boolean
  //是否主动关闭socket
  isTakeClose: boolean
  //网络状态
  onlineOrOffline: boolean
  interval: any
  sessionId: string
  userId: string
  merchantInfo: IMessageMerchantParam
  userInfo: IMessageUserParam
  audioIns: any
  queryType: string
  showWrite: any
  hasSuperviseInfo: boolean
  isGoDetail: boolean
  hasOrderInfo: boolean
  isGoOrderDetail: boolean
  orderRandomNum: any
}

interface IMessageMerchantParam {
  merchantId?: string
  merchantName?: string
  merchantImgUrl?: string
}

interface IMessageUserParam {
  userId?: string
  userImgUrl?: string
}

/**
 * 消息类型
 */
export enum MessageType {
  Audio = 'AUDIO',
  Emoji = 'EMOJI',
  File = 'FILE',
  Image = 'IMAGE',
  Text = 'TEXT',
  Tip = 'TIP',
  Video = 'VIDEO'
}

export enum UserType {
  CustomerService = 'CUSTOMER_SERVICE',
  System = 'SYSTEM',
  User = 'USER',
  EMPLOYEE = 'EMPLOYEE'
}

/**
 * 同事帮忙结束（F2）时，后端（/endAndRemoveAll）会把这条会话从所有接待客服的列表里移出。
 * 收到「会话结束」推送后稍等一下（等后端事务做完），对一遍服务器上的列表：这条会话已经不在了，
 * 就从本地列表里去掉（正在看的话把聊天窗口也切走）。不调 init()：它会把输入状态改成列表第一条的状态。
 * 玩家自己结束、超时自动结束的会话还在服务器列表里，保持原来的「已结束」不动。
 */
const scheduleEndedSessionPrune = (sessionId: any) => {
  const endedSid = sessionId + ''
  setTimeout(async () => {
    try {
      const res: any = await querySessionList({})
      if (!res || res.code != '0') return
      const serverIds = new Set((res.data || []).map((v: any) => v.sessionId + ''))
      if (serverIds.has(endedSid)) return
      const store = useChatListStore()
      const i = (store.chatList || []).findIndex((v: any) => v.sessionId + '' === endedSid)
      if (i > -1) store.chatList.splice(i, 1)
      if (useMessageStore().sessionId + '' === endedSid) useMessageStore().switchMessage()
    } catch (e) {
      // 对列表失败不打扰客服，列表上留着一条已结束的会话，手动清掉就行
    }
  }, 1500)
}

export const useWebSocketStore = defineStore('websocket', {
  state: (): IWebSocket => {
    return {
      ws: null,
      isConnected: true,
      isTakeClose: false,
      onlineOrOffline: true,
      interval: null,
      sessionId: '',
      userId: '',
      merchantInfo: {},
      userInfo: {},
      audioIns: null,
      queryType: 'all',
      showWrite: '',
      hasSuperviseInfo: false,
      isGoDetail: false,
      hasOrderInfo: false,
      isGoOrderDetail: false,
      orderRandomNum: null
    }
  },

  actions: {
    // setTest(){
    //   setInterval(()=>{
    //     if(!this.hasSuperviseInfo&&!this.isGoDetail){
    //     this.playTImeoutAudio()
    //     this.hasSuperviseInfo=true
    //     ElNotification({
    //       title: '',
    //       message:`<div>${t('t_timeout_reply_msg')}
    //           <a  href="/checkNew" style="margin-left: 10px;cursor:pointer;color:#2988f4;" class="timeout-line">${t('t_timeout_detail')}</a>
    //       </div>`,
    //       icon:WarnTriangleFilled,
    //       dangerouslyUseHTMLString: true,
    //       customClass:'warnTriangle',
    //       duration:0,
    //       type: '',
    //       // showClose:false,
    //       position: 'bottom-right', // 设置显示在右下角
    //     })
    //     }
    //   },5000)
    // },
    // 设置已进入详情页
    goDetailPage() {
      this.isGoDetail = true
    },
    goOrderDetailPage() {
      this.isGoOrderDetail = true
    },
    // 设置出详情页
    goOutDetailPage() {
      this.isGoDetail = false
    },
    goOutOrderDetailPage() {
      this.isGoOrderDetail = false
    },
    // 关闭超时消息标识
    closeSuperviseInfo() {
      this.hasSuperviseInfo = false
    },
    // 关闭工单消息标识
    closeOrderInfo() {
      this.hasOrderInfo = false
    },
    //---------------------------功能相关------------------------------------
    /**
     * 塞入sessionId
     * @param value
     */
    setSessionId(value: string) {
      if (!value) return
      this.sessionId = value
    },
    /**
     * 塞入UserId
     */
    setUserId(value: string) {
      if (!value) return
      this.userId = value
    },
    // setShowWrite(value: boolean) {
    //   this.showWrite = value
    // },

    //--------------------------websocket相关--------------------------------------
    //连接
    connect() {
      if (
        this.ws &&
        (this.ws.readyState == WebSocket.OPEN || this.ws.readyState == WebSocket.CONNECTING)
      ) {
        // console.log(`连接已建立，无需再次连接`, this.ws.readyState)
        return
      }
      // const wsUrl = import.meta.env.VITE_WS_URL
      const localtion = window.location.hostname
      const port = window.location.port
      const gateway = import.meta.env.VITE_GATEWAY
      this.ws = new WebSocket(
        `${wsBase}://${localtion}:${port}${gateway}/msg/ws/join/employee?token=${
          useUserStore().token
        }`
      )

      this.ws.addEventListener('open', () => {
        // console.log('WebSocket连接已建立')
        //断开连接后，重新初始化聊天列表
        const obj: any = {}
        if (this.queryType == 'ZALO') {
          obj.thirdApp = ThirdApp.Zalo
        }
        if (this.queryType == 'TELEGRAM') {
          obj.thirdApp = ThirdApp.Telegram
        }
        if (this.queryType == 'TWITTER') {
          obj.thirdApp = ThirdApp.Twitter
        }
        if (this.queryType == 'MESSAGER') {
          obj.thirdApp = ThirdApp.Messager
        }
        if (this.queryType == 'WHATSAPP') {
          obj.thirdApp = ThirdApp.WhatsApp
        }
        if (this.queryType == 'LINE') {
          obj.thirdApp = ThirdApp.Line
        }
        if (this.queryType == 'RCS') {
          obj.thirdApp = ThirdApp.Rcs
        }
        obj.showEnd = false
        useChatListStore().searchSessionList(obj)
        //连接后查询聊天记录
        // useMessageStore().refreshMsgHistory()
        this.isConnected = true
        this.isTakeClose = false
      })

      // this.ws.addEventListener('close', (e: any) => {
      //   this.isConnected = false
      //   console.error('WebSocket连接断开', JSON.stringify(e), this.isTakeClose)
      // })
      this.ws.addEventListener('close', (e: any) => {
        this.isConnected = false
        console.error('WebSocket连接断开', JSON.stringify(e))
        this.cancelHeart()
        if (!this.isTakeClose && !this.isConnected) {
          console.error('WebSocket意外断开，正在尝试重新连接...')
          setTimeout(() => {
            this.connect()
          }, 1000)
        }
      })

      this.ws.addEventListener('message', (event: any) => {
        // debugger
        console.log('Message from Server: ' + event.data)
        // {"content":{"body":"了不起\n","messageTypeEnum":"TEXT","sendTime":"2023-04-10 18:21:22","sendUserId":1644283040761372673,"sessionId":1644283040826044417},"eventTime":"2023-04-10 18:21:22","eventType":"SEND_MSG"}
        if (event.data && event.data != 'pong') {
          const messageInfo: any = JSON.parse(JSON.parse(JSON.stringify(event.data)))
          if (messageInfo?.eventType == 'SESSION_END' && messageInfo?.content?.sessionId) {
            scheduleEndedSessionPrune(messageInfo.content.sessionId)
          }
          if (messageInfo && messageInfo?.eventId) {
            //收到消息，回复
            this.send({
              eventId: messageInfo.eventId + '',
              eventTime: new Date(),
              eventType: 'RECEIVE_REPLY'
            })
          }
          if (messageInfo.eventType == 'MSG_NOTICE') {
            if (messageInfo.noticeType == '2') {
              ElMessageBox.alert(messageInfo.title, t('EMPLOYEE.supervisor'), {
                customClass: 'msgInfo'
              })
            } else if (messageInfo.noticeType == '3') {
              // noticeError({
              //   title: ``,
              //   message: `123123123`,
              //   icon:'WarnTriangleFilled'
              // })
              // debugger
              if (!this.hasSuperviseInfo && !this.isGoDetail) {
                ElNotification.closeAll()
                this.playTImeoutAudio()
                this.hasSuperviseInfo = true
                const userAgent = navigator.userAgent || navigator.vendor || window.opera
                // |ipad
                let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
                  userAgent
                )
                if (!flag) {
                  ElNotification({
                    title: '',
                    message: `<div>${t('t_timeout_reply_msg')}
                        <a  href="/checkNew" style="margin-left: 10px;cursor:pointer;color:#2988f4;" class="timeout-line">${t(
                          't_timeout_detail'
                        )}</a>
                    </div>`,
                    icon: WarnTriangleFilled,
                    dangerouslyUseHTMLString: true,
                    customClass: 'warnTriangle',
                    duration: 0,
                    type: '',
                    // showClose:false,
                    position: 'bottom-right' // 设置显示在右下角
                  })
                }
              }
            } else if (messageInfo.noticeType == '4') {
              this.orderRandomNum = Math.random() * (10000 - 0) + 0
              if (!this.hasOrderInfo && !this.isGoOrderDetail) {
                ElNotification.closeAll()
                this.playTImeoutAudio()
                this.hasOrderInfo = true
                const userAgent = navigator.userAgent || navigator.vendor || window.opera
                // |ipad
                let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
                  userAgent
                )
                if (!flag) {
                  ElNotification({
                    title: '',
                    message: `<div>${t('t_timeout_order_msg')}
                        <a  href="/workorder" style="margin-left: 10px;cursor:pointer;color:#2988f4;" class="timeout-line">${t(
                          't_timeout_detail'
                        )}</a>
                    </div>`,
                    icon: WarnTriangleFilled,
                    dangerouslyUseHTMLString: true,
                    customClass: 'warnTriangle',
                    duration: 0,
                    type: '',
                    // showClose:false,
                    position: 'bottom-right' // 设置显示在右下角
                  })
                }
              }
            }
          } else if (messageInfo?.eventType && messageInfo?.eventType == 'SESSION_USER_STATUS') {
            const list = useChatListStore().chatList || []
            if (list.length > 0) {
              const indexSession = list.findIndex(
                (v) => v.sessionId === messageInfo.content.sessionId
              )
              if (indexSession !== -1 && list[indexSession] && list[indexSession].userInfo) {
                list[indexSession].userInfo.onlineStatus = messageInfo.content.userOnlineStatus
              }
            }
          } else if (messageInfo.eventType == 'STOP_RECONNECTION') {
            this.close()
          } else if (
            messageInfo.eventType == 'WRITEON' ||
            messageInfo.eventType == 'WRITEOFF' ||
            messageInfo.eventType == 'READ'
          ) {
            // console.log(useMessageStore().sessionId)
            if (messageInfo.serviceId == useMessageStore().sessionId) {
              if (messageInfo.eventType == 'WRITEON') {
                this.showWrite = messageInfo.serviceId
              } else if (messageInfo.eventType == 'WRITEOFF') {
                this.showWrite = ''
              } else {
                useMessageStore().setUnReadId(useMessageStore().sessionId, [])
                // console.log(useMessageStore().readSessions)
              }
            }
          } else {
            //是否是当前会话
            // debugger;
            const userAgent = navigator.userAgent || navigator.vendor || window.opera
            // |ipad
            let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
            // !flag
            let mobileInChat = useMessageStore().mobileInChat
            // &&(!flag||mobileInChat)
            console.log(messageInfo.content.sessionId, 'sessionId')
            console.log(useMessageStore().sessionId, 'sessionId')
            if (messageInfo.content.sessionId == useMessageStore().sessionId) {
              if (
                messageInfo.eventType != 'SESSION_END' &&
                !(
                  messageInfo.eventType == 'MSG_SEND' &&
                  messageInfo.content.msgType == 'TIP' &&
                  messageInfo.content.body == '本次会话已结束，感谢您的咨询，祝您生活愉快～'
                )
              ) {
                if (!flag || (flag && mobileInChat)) {
                  console.log(flag, 'flag')
                  console.log(mobileInChat, 'mobileInChat')
                  useChatListStore().sessionAllRead(messageInfo.content.sessionId + '')
                }
              }
              // useChatListStore().sessionAllRead(messageInfo.content.sessionId + '')

              //处理会话 ->
              if (messageInfo && messageInfo.content && messageInfo.content.body) {
                let userType = UserType.System
                if (messageInfo.content.msgType == 'TIP') {
                  userType = UserType.System
                } else if (messageInfo.content.sendUserId == useUserStore().id) {
                  userType = UserType.CustomerService
                } else if (messageInfo.content.sendUserId != useUserStore().id) {
                  if (
                    messageInfo.content.senderType == '0' ||
                    messageInfo.content.senderType == '1'
                  ) {
                    userType = UserType.CustomerService
                  } else if (!messageInfo.content.sendUserId) {
                    //console.log("messageInfo===================",messageInfo)
                    userType = UserType.System
                  } else {
                    userType = UserType.User
                  }
                }
                const obj = {
                  id: messageInfo.content?.recordId ?? uuidv4(),
                  userType: userType,
                  messageType:
                    messageInfo.content?.messageTypeEnum || messageInfo.content?.msgType || 'TEXT',
                  content: messageInfo.content?.body ?? '',
                  sendTime: messageInfo.content?.sendTime ?? '',
                  sendUserId: messageInfo.content?.sendUserId ?? '',
                  translationText: messageInfo.content?.translationText ?? '',
                  withdraw: false,
                  aiFlag: messageInfo.content?.aiFlag ?? false,
                  recordFileKeys: messageInfo?.content?.recordFileKeys || []
                }
                if (messageInfo.content.tmpId) {
                  // debugger;
                  console.log(useMessageStore().data)
                  let index = useMessageStore().data.findIndex(
                    (arr) => arr.tmpId == messageInfo.content.tmpId
                  )
                  // 评价类型则不翻译
                  if (
                    messageInfo.content.msgType == 'EVALUATE' ||
                    userType == UserType.CustomerService ||
                    useMessageStore().translationSwitch == false
                  ) {
                    if (index == -1) {
                      useMessageStore().setData(obj)
                    } else {
                      useMessageStore().data[index] = obj
                    }
                  } else {
                    translateByOneID({ msgId: obj.id })
                      .then((res: any) => {
                        if (res.code && res.code == '0') {
                          // obj.content=res.data
                          obj.translationText = res.data
                          if (index == -1) {
                            useMessageStore().setData(obj)
                          } else {
                            useMessageStore().data[index] = obj
                          }
                        }
                      })
                      .catch((err) => {
                        if (index == -1) {
                          useMessageStore().setData(obj)
                        } else {
                          useMessageStore().data[index] = obj
                        }
                      })
                  }
                } else {
                  if (
                    messageInfo.content.msgType == 'EVALUATE' ||
                    userType == UserType.CustomerService ||
                    useMessageStore().translationSwitch == false
                  ) {
                    useMessageStore().setData(obj)
                  } else {
                    translateByOneID({ msgId: obj.id })
                      .then((res: any) => {
                        if (res.code && res.code == '0') {
                          // obj.content=res.data
                          obj.translationText = res.data
                          useMessageStore().setData(obj)
                        }
                      })
                      .catch((err) => {
                        useMessageStore().setData(obj)
                      })
                  }
                  // this.newMessageNumber = this.newMessageNumber + 1
                }

                //塞入聊天数据
                // useMessageStore().setData(obj)
                if (userType == UserType.User) {
                  //播放语音
                  this.playAudio(messageInfo)
                  useMessageStore().setCountdownStartTime('')
                }
                //异步调用最新一条记录
                this.updateChatListStore(messageInfo, false)
              } else if (messageInfo && messageInfo.eventType) {
                //处理<EventType>
                if (messageInfo.eventType == 'SESSION_TRANSFER') {
                  //会话转出
                  // {"content":{"newEmployeeId":"1642757977402306562","oldEmployeeId":"1639084819549843458","sessionId":"1645767774944808961"},"eventTime":"2023-04-14 10:24:11","eventType":"SESSION_TRANSFER"}
                  //需要从聊天会话框中删除该会话。
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  useChatListStore().searchSessionList(obj)
                  // if (
                  //   messageInfo.content &&
                  //   messageInfo.content.newEmployeeId &&
                  //   messageInfo.content.oldEmployeeId
                  // ) {
                  //   console.log(messageInfo)
                  //   if (messageInfo.content.newEmployeeId != useUserStore().id) {

                  useTranslatChangeStore().closeSelf()
                  useMessageStore().switchMessage()
                  //     useMessageStore().status = 'END'
                  //     const list = useChatListStore().chatList || []
                  //     let index = list.findIndex(v => v.sessionId === messageInfo.content.sessionId)
                  //     list[index].status = 'END'
                  //     useChatListStore().setChatList(list, list[index].sessionId)
                  //     // useChatListStore().pushChatListChange(useMessageStore().sessionId)
                  //   } else {
                  //     useMessageStore().status = 'CS_ACCESS'
                  //     const list = useChatListStore().chatList || []
                  //     let index = list.findIndex(v => v.sessionId === messageInfo.content.sessionId)
                  //     console.log(index,list)
                  //     if (index != -1) {
                  //       list[index].status = 'CS_ACCESS'
                  //       useChatListStore().setChatList(list, list[index].sessionId)
                  //     }
                  //   }
                  // }
                } else if (messageInfo.eventType == 'SESSION_END') {
                  useMessageStore().status = 'END'
                  const list = useChatListStore().chatList || []
                  const indexSession = list.findIndex(
                    (v) => v.sessionId === messageInfo.content.sessionId
                  )
                  list[indexSession].status = 'END'
                  // debugger
                  // caicai
                  // useChatListStore().setChatList(list, list[indexSession].sessionId)
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  // useChatListStore().searchSessionList(obj)
                  const index = this.showWrite.indexOf(messageInfo.content.sessionId)
                  if (index != -1) {
                    this.showWrite.splice(index, 1)
                  }
                  // useChatListStore().chatList.splice(useChatListStore().chatList.findIndex(v => v.sessionId === messageInfo.content.sessionId), 1)
                  //会话结束
                  //逻辑层处理放在 接口处理了。 不需要特别处理
                } else if (messageInfo.eventType == 'SESSION_NEW') {
                  useMessageStore().status = 'CS_ACCESS'
                  const list = useChatListStore().chatList || []
                  let index = list.findIndex((v) => v.sessionId === messageInfo.content.sessionId)
                  if (index != -1) {
                    list[index].status = 'CS_ACCESS'
                    // useChatListStore().setChatList(list, list[index].sessionId)
                  }
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  obj.showEnd = false
                  useChatListStore().searchSessionList(obj)
                  useMessageStore().setCountdownStartTime('')
                  // useChatListStore().chatList.splice(useChatListStore().chatList.findIndex(v => v.sessionId === messageInfo.content.sessionId), 1)
                  //会话结束
                  //逻辑层处理放在 接口处理了。 不需要特别处理
                } else if (messageInfo.eventType == 'SESSION_PRE_TRANSFER') {
                  useTranslatChangeStore().setParam(messageInfo.content)
                  useTranslatChangeStore().show()
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  useChatListStore().searchSessionList(obj)
                } else if (messageInfo.eventType == 'MSG_WITHDRAW') {
                  //消息撤回
                  // Message from Server: {"content":{"recordId":"1660923115717111810","sessionId":"1660571902168178689"},"eventTime":"2023-05-23 16:20:03.514","eventType":"MSG_WITHDRAW"}
                  this.widthDrawMessage(messageInfo)
                } else if (
                  messageInfo?.eventType &&
                  messageInfo?.eventType == 'MSG_SENSITIVE_KEY_WARN'
                ) {
                  //敏感词被触发
                  this.playWarningAudio(messageInfo)
                }
              }
            } else {
              //处理消息列表 未读消息
              //获取chatListStore.chatList
              const obj1: any = {}
              if (this.queryType == 'ZALO') {
                obj1.thirdApp = ThirdApp.Zalo
              }
              if (this.queryType == 'TELEGRAM') {
                obj1.thirdApp = ThirdApp.Telegram
              }
              if (this.queryType == 'TWITTER') {
                obj1.thirdApp = ThirdApp.Twitter
              }
              if (this.queryType == 'MESSAGER') {
                obj1.thirdApp = ThirdApp.Messager
              }
              if (this.queryType == 'WHATSAPP') {
                obj1.thirdApp = ThirdApp.WhatsApp
              }
              if (this.queryType == 'LINE') {
                obj1.thirdApp = ThirdApp.Line
              }
              if (this.queryType == 'RCS') {
                obj1.thirdApp = ThirdApp.Rcs
              }
              obj1.showEnd = false
              // useChatListStore().searchSessionList(obj1)
              const list = useChatListStore().chatList || []
              let len = -1
              if (list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].sessionId == messageInfo.content.sessionId) {
                    len = i
                  }
                }
              }
              if (len > -1) {
                // let chatItem = list.splice(len, 1)[0]
                // let chatItem = ;"EVALUATE"
                // debugger
                // 限制下类型
                if (
                  !useUserStore().isCurrentUser(messageInfo?.content.sendUserId) &&
                  messageInfo.eventType == 'MSG_SEND' &&
                  (messageInfo.content.msgType == 'TEXT' ||
                    messageInfo.content.msgType == 'EVALUATE' ||
                    messageInfo.content.msgType == 'IMAGE' ||
                    messageInfo.content.msgType == 'FILE' ||
                    messageInfo.content.msgType == 'VIDEO' ||
                    messageInfo.content.msgType == 'AUDIO')
                ) {
                  //处理未读消息
                  // caicai
                  list[len].unreadNum = list[len]?.unreadNum ? Number(list[len].unreadNum) + 1 : 1
                  list[len].autoEndCountdownStartTime = '';
                }

                //处理最后一条消息
                // caicai
                // 去除标签
                let bodyTxt = messageInfo?.content?.body ?? list[len].lastMsg?.body ?? ''
                list[len].lastMsg = {
                  body: bodyTxt.replace(/<[^>]*>/g, ''),
                  sendTime: timeUtilNowMoment(),
                  senderInfo: {
                    id: messageInfo?.content?.senderUserId || ''
                  },
                  msgType: messageInfo.content?.msgType || 'TEXT'
                }
                if (messageInfo.eventType == 'SESSION_NEW') {
                  list[len].status = 'CS_ACCESS'
                  // debugger
                  useMessageStore().status = 'CS_ACCESS'
                  let list2 = useChatListStore().chatList || []
                  let index = list2.findIndex((v) => v.sessionId === messageInfo.content.sessionId)
                  if (index != -1) {
                    list2[index].status = 'CS_ACCESS'
                    list2[index].userInfo.onlineStatus = 'ONLINE'
                    useChatListStore().setChatList(list2, list2[index].sessionId)
                  }
                } else if (messageInfo.eventType == 'SESSION_END') {
                  list[len].status = 'END'
                  // let list2 = useChatListStore().chatList || []
                  // let index = list2.findIndex((v) => v.sessionId === messageInfo.content.sessionId)
                  // if (index != -1) {
                  //   list2[index].status = 'END'
                  //   list2[index].userInfo.onlineStatus = 'ONLINE'
                  //   useChatListStore().setChatList(list2, list2[index].sessionId)
                  // }
                } else if (messageInfo.eventType == 'SESSION_PRE_TRANSFER') {
                  useTranslatChangeStore().setParam(messageInfo.content)
                  useTranslatChangeStore().show()
                  return
                }
                // useChatListStore().setChatList(list, list[len].sessionId)
                const obj: any = {}
                if (this.queryType == 'ZALO') {
                  obj.thirdApp = ThirdApp.Zalo
                }
                if (this.queryType == 'TELEGRAM') {
                  obj.thirdApp = ThirdApp.Telegram
                }
                if (this.queryType == 'TWITTER') {
                  obj.thirdApp = ThirdApp.Twitter
                }
                if (this.queryType == 'MESSAGER') {
                  obj.thirdApp = ThirdApp.Messager
                }
                if (this.queryType == 'WHATSAPP') {
                  obj.thirdApp = ThirdApp.WhatsApp
                }
                if (this.queryType == 'LINE') {
                  obj.thirdApp = ThirdApp.Line
                }
                if (this.queryType == 'RCS') {
                  obj.thirdApp = ThirdApp.Rcs
                }
                if (
                  messageInfo &&
                  messageInfo.content &&
                  messageInfo.content.sessionId &&
                  messageInfo.eventType &&
                  useChatListStore().loadSessionList.indexOf(messageInfo.content.sessionId) == -1
                ) {
                  // debugger
                  useChatListStore().chatList.forEach((i) => {
                    if (
                      i.sessionId == messageInfo.content.sessionId &&
                      messageInfo.eventType == 'MSG_SEND' &&
                      messageInfo.content.msgType == 'TEXT'
                    ) {
                      // debugger
                      i.unreadNum = i.unreadNum ? i.unreadNum++ : 0
                      // i.status = 'CS_ACCESS'
                    }
                  })
                  // caicai
                  // debugger
                  // useMessageStore().status = 'CS_ACCESS'
                  // let list = useChatListStore().chatList || []
                  // let index = list.findIndex((v) => v.sessionId === messageInfo.content.sessionId)
                  // if (index != -1) {
                  //   list[index].status = 'CS_ACCESS'
                  //   useChatListStore().setChatList(list, list[index].sessionId)
                  // }
                  //  useChatListStore().searchSessionList(obj)
                }
              } else {
                if (
                  messageInfo &&
                  messageInfo.content &&
                  messageInfo.content.sessionId &&
                  messageInfo.eventType &&
                  messageInfo.eventType == 'SESSION_NEW'
                ) {
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  useChatListStore().searchSessionList(obj)
                  useChatListStore().addNewSession(messageInfo.content)
                  // useChatListStore().getChatListSingle(messageInfo.content.sessionId)
                }
                if (
                  messageInfo &&
                  messageInfo.content &&
                  messageInfo.content.sessionId &&
                  messageInfo.eventType &&
                  messageInfo.eventType == 'SESSION_END'
                ) {
                  // debugger
                  const obj: any = {}
                  if (this.queryType == 'ZALO') {
                    obj.thirdApp = ThirdApp.Zalo
                  }
                  if (this.queryType == 'TELEGRAM') {
                    obj.thirdApp = ThirdApp.Telegram
                  }
                  if (this.queryType == 'TWITTER') {
                    obj.thirdApp = ThirdApp.Twitter
                  }
                  if (this.queryType == 'MESSAGER') {
                    obj.thirdApp = ThirdApp.Messager
                  }
                  if (this.queryType == 'WHATSAPP') {
                    obj.thirdApp = ThirdApp.WhatsApp
                  }
                  if (this.queryType == 'LINE') {
                    obj.thirdApp = ThirdApp.Line
                  }
                  if (this.queryType == 'RCS') {
                    obj.thirdApp = ThirdApp.Rcs
                  }
                  // useChatListStore().searchSessionList(obj)
                  const index = this.showWrite.indexOf(messageInfo.content.sessionId)
                  if (index != -1) {
                    this.showWrite.splice(index, 1)
                  }
                  // console.log(111)
                  // setTimeout(() => {
                  //   //需要根据sessionId查询会话信息，然后塞入chatListStore
                  //   useChatListStore().getChatListSingle(messageInfo.content.sessionId)
                  // }, 1000)
                  //这里延迟一秒，等待后端事务执行完成之后，再走该程序
                } else if (
                  messageInfo &&
                  messageInfo.content &&
                  messageInfo.content.sessionId &&
                  messageInfo.eventType &&
                  messageInfo.eventType == 'MSG_SEND' &&
                  messageInfo.content.noGroove
                ) {
                  setTimeout(() => {
                    //需要根据sessionId查询会话信息，然后塞入chatListStore
                    useChatListStore().getChatListSingle(messageInfo.content.sessionId)
                  }, 2500)
                  //这里延迟一秒，等待后端事务执行完成之后，再走该程序
                } else if (
                  messageInfo.content &&
                  messageInfo.content.sessionId &&
                  messageInfo.content.newEmployeeId &&
                  messageInfo.content.oldEmployeeId &&
                  messageInfo.eventType &&
                  messageInfo.eventType == 'SESSION_TRANSFER'
                ) {
                  //其他会话转过来，需要添加
                  if (messageInfo.content.newEmployeeId == useUserStore().id) {
                    useMessageStore().status = 'CS_ACCESS'
                    const list = useChatListStore().chatList || []
                    const index = list.findIndex(
                      (v) => v.sessionId === messageInfo.content.sessionId
                    )
                    if (index != -1) {
                      list[index].status = 'CS_ACCESS'
                      useChatListStore().setChatList(list, list[index].sessionId)
                    } else {
                      setTimeout(() => {
                        //需要根据sessionId查询会话信息，然后塞入chatListStore
                      useChatListStore().getChatListSingle(messageInfo.content.sessionId)
                      }, 1000)
                    }
                  }
                  // //其他会话转过来，需要添加
                  // if (messageInfo.content.newEmployeeId == useUserStore().id) {
                  //   useChatListStore().getChatListSingle(messageInfo.content.sessionId)
                  // }
                } else if (
                  messageInfo?.content?.sessionId &&
                  messageInfo.eventType &&
                  messageInfo.eventType == 'SESSION_PRE_TRANSFER'
                ) {
                  // Message from Server: {"content":{"merchantName":"米哈游","newEmployeeId":"1651545668950728705","nickName":"001","oldEmployeeId":"1650033308414439425","reason":"","sessionId":"1663085357650616321","userLabelReplies":[]},"eventTime":"2023-06-06 15:30:30.671","eventType":"SESSION_PRE_TRANSFER"}
                  useTranslatChangeStore().setParam(messageInfo.content)
                  useTranslatChangeStore().show()
                } else if (
                  messageInfo?.eventType &&
                  messageInfo.eventType == 'MSG_SENSITIVE_KEY_WARN'
                ) {
                  //会话监管 - 告警信息
                  this.playWarningAudio(messageInfo)
                }
              }
              this.sendNotice(messageInfo)
              //播放音频
              this.playAudio(messageInfo)
            }
          }
        }
      })
    },
    widthDrawMessage(messageInfo: any) {
      const messageData = useMessageStore().widthDrawMessage(messageInfo.content.recordId)
      //如果撤回的消息为最后一条 则更新当前聊天的列表的最后一条消息的内容为撤回
      if (messageData && toRaw(useMessageStore().getLatestNews()) === messageData) {
        if (messageInfo.content) {
          messageInfo.content.body = messageData.content
          messageInfo.content.msgType = messageData.messageType
          messageInfo.content.withDraw = messageData.withdraw
        }
        this.updateChatListStore(messageInfo, false)
      }
    },
    /**
     * 发送websocket消息
     *
     * @param data
     */
    send(data: any) {
      try {
        if (this.isConnected) {
          this.ws.send(JSON.stringify(data))
        } else {
          // const status = this.webSokcetStatus()
          // if (status !== WebSocket.OPEN || status !== WebSocket.CONNECTING) {
          //   this.connect()
          //   this.keepHeart()
          // }
        }
      } catch (error) {
        // console.log(error)
      }
    },
    /**
     * 关闭websocket连接
     */
    async close() {
      this.isConnected = false
      this.isTakeClose = true
      //清空定时器
      this.hasSuperviseInfo = false
      ElNotification.closeAll()
      this.ws && this.ws.close()
      this.ws &&
        this.ws.removeEventListener('message', () => {
          // console.log('断开消息监听')
        })
      this.ws &&
        this.ws.removeEventListener('open', () => {
          // console.log('断开连接监听')
        })
      this.ws &&
        this.ws.removeEventListener('close', () => {
          // console.log('断开关闭监听')
        })

      this.cancelHeart()
    },
    /**
     * 维持socket心跳
     *
     */
    keepHeart() {
      if (this.interval) {
        // console.log('定时器已存在，无需ping')
        return
      }

      this.interval = setInterval(() => {
        this.send('ping')
      }, 6000)
    },

    /**
     * 取消socket心跳
     */
    cancelHeart() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    updateChatListStore(messageInfo: any, isNeedUpdate: boolean) {
      // debugger;
      // userType判断
      let isCustomerService = false
      if (messageInfo.content.sendUserId == useUserStore().id) {
        isCustomerService = true
      } else if (messageInfo.content.sendUserId != useUserStore().id) {
        if (messageInfo.content.senderType == '0' || messageInfo.content.senderType == '1') {
          isCustomerService = true
        }
      }

      const list = useChatListStore().chatList || []
      let len = -1
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].sessionId == messageInfo.content.sessionId) {
            len = i
          }
        }
      }
      if (len > -1) {
        // let chatItem = list.splice(len, 1)[0]
        // let chatItem = ;
        //处理未读消息
        if (isNeedUpdate) {
          list[len].unreadNum = list[len]?.unreadNum ? Number(list[len].unreadNum) + 1 : 1
        }
        if (list[len].userInfo && list[len].userInfo.onlineStatus === 'OFFLINE') {
          list[len].userInfo.onlineStatus = 'ONLINE'
        }
        const msgId = messageInfo.content?.recordId ?? uuidv4()
        // 如果是客服自己则不翻译
        if (isCustomerService || useMessageStore().translationSwitch == false) {
          //处理最后一条消息
          list[len].lastMsg = {
            body: messageInfo?.content?.body ?? '',
            sendTime: timeUtilNowMoment(),
            senderInfo: {
              id: messageInfo.content.sendUserId || ''
            },
            msgType: messageInfo?.content.msgType || MessageType.Text,
            withDraw: messageInfo?.content?.withDraw || false
          }
          if(messageInfo?.content.msgType != 'TIP' && !isCustomerService){
            list[len].autoEndCountdownStartTime = '';
            useMessageStore().setCountdownStartTime('')
          }
          useChatListStore().setChatList(list, list[len].sessionId)
        } else {
          translateByOneID({ msgId }).then((res: any) => {
            if (res.code && res.code == '0') {
              const resultTxt = res.data ? res.data : ''
              //处理最后一条消息
              list[len].lastMsg = {
                // body: messageInfo?.content?.body ?? '',
                body: resultTxt,
                sendTime: timeUtilNowMoment(),
                senderInfo: {
                  id: messageInfo.content.sendUserId || ''
                },
                msgType: messageInfo?.content.msgType || MessageType.Text,
                withDraw: messageInfo?.content?.withDraw || false
              }

              if(messageInfo?.content.msgType != 'TIP'){
                list[len].autoEndCountdownStartTime = '';
                useMessageStore().setCountdownStartTime('')
              }
               
              useChatListStore().setChatList(list, list[len].sessionId)
            }
          })
        }
      }
    },

    webSokcetStatus() {
      if (this.ws) {
        return this.ws.readyState
      } else {
        return WebSocket.CLOSED
      }
    },

    setOnline(value: boolean) {
      this.onlineOrOffline = value
    },

    //语音消息提醒
    playAudio(messageInfo?: any) {
      if (messageInfo?.eventType && messageInfo?.eventType == 'MSG_SENSITIVE_KEY_WARN') {
        return
      }

      if (this.audioIns != null) {
        this.audioIns.pause()
        this.audioIns = null
      }
      if (!useUserStore().enableNoticeMusic) return
      let url = ''
      if (useUserStore().noticeMusicUrl) {
        url = useUserStore().noticeMusicUrl
      } else {
        url = useUserStore().audioSystemUrls[0].url
      }
      // var playPromise;
      this.audioIns = new Audio(`${url}`)
      if (
        messageInfo.eventType == 'MSG_SEND' &&
        messageInfo.content &&
        messageInfo.content.msgType != 'TIP'
      ) {
        this.audioIns.play()
      }
    },

    //告警提示音
    playWarningAudio(messageInfo?: any) {
      noticeWarning({
        title: 'Sensitive Word Warning',
        message: `Sensitive words are triggered:${messageInfo?.content?.sensitiveKey}`
      })
      if (this.audioIns != null) {
        this.audioIns.pause()
        this.audioIns = null
      }
      if (!useUserStore().enableNoticeMusic) return
      let url = ''
      if (useUserStore().warnMusicUrl) {
        url = useUserStore().warnMusicUrl
      } else {
        url = useUserStore().audioWarningUrls[0].url
      }

      this.audioIns = new Audio(`${url}`)
      this.audioIns.play()
      console.log(this.audioIns)
      console.log(url, 'urlurl')
    },
    //告警提示音
    playTImeoutAudio() {
      if (this.audioIns != null) {
        this.audioIns.pause()
        this.audioIns = null
      }
      if (!useUserStore().enableNoticeMusic) return
      let url = ''
      if (useUserStore().warnMusicUrl) {
        url = useUserStore().warnMusicUrl
      } else {
        url = useUserStore().audioWarningUrls[0].url
      }

      this.audioIns = new Audio(`${url}`)
      this.audioIns.play()
      console.log(this.audioIns)
      console.log(url, 'urlurl')
    },
    sendNotice(messageInfo: any) {
      // message: 'you have a new message',
      // 您有一条新消息！
      // && useUserStore()
      /* console.log("messageInfo", messageInfo)
      console.log("userId",useUserStore().id)
      console.log("messageInfo.content.senderUserId",messageInfo.content.sendUserId) */
      //console.log("this.$t('CHAT.no_chat')", this.$t('CHAT.no_chat'))
      if (
        messageInfo.eventType == 'MSG_SEND' &&
        messageInfo.content &&
        messageInfo.content.msgType != 'TIP' &&
        useUserStore().id != messageInfo.content.sendUserId &&
        useChatListStore().unReadNumber > 0
      ) {
        ElMessage({
          message: t('COMMON.notification'),
          grouping: true,
          type: 'warning'
        })
      }

      // console.log(this.isBrowserHidden())
      // if (useUserStore().isAllowNotice == 1 && this.isBrowserHidden()) {
      //   const notification = new Notification('Message Notification', {
      //     body: `${body}`,
      //     icon: 'https://github.com/krislee94/img-service/assets/26591239/61b821d5-2df0-41af-849c-38a0bac23ca4'
      //   })
      //   console.log('111111', notification)
      //   // 点击通知时的操作
      //   notification.onclick = function () {
      //     console.log('通知被点击')
      //   }
      // }
    },

    isBrowserHidden() {
      return document.visibilityState === 'hidden'
    },

    presist: {
      path: ['interval'],
      storage: sessionStorage
    }
  }
})
